
import React from "react";
import { Search, Loader2 } from "lucide-react";

interface ProductSearchResult {
  product_naam: string;
  product_id: string;
  bc: string;
  eenheid: string;
}

interface ProductSearchResultsProps {
  isLoading: boolean;
  results: ProductSearchResult[];
  selectProduct: (product: ProductSearchResult) => void;
  visible: boolean;
}

const ProductSearchResults = ({
  isLoading,
  results,
  selectProduct,
  visible
}: ProductSearchResultsProps) => {
  if (!visible) return null;

  return (
    <div className="absolute z-10 w-full mt-1 bg-white border rounded-md shadow-lg max-h-60 overflow-auto">
      {isLoading ? (
        <div className="p-2 text-center">
          <Loader2 className="h-4 w-4 animate-spin inline mr-2" />
          Zoeken...
        </div>
      ) : results.length > 0 ? (
        <ul>
          {results.map((result, idx) => (
            <li
              key={idx}
              className="p-2 hover:bg-gray-100 cursor-pointer flex items-center gap-2"
              onMouseDown={() => selectProduct(result)}
            >
              <Search className="h-3 w-3 text-gray-400" />
              <div>
                <div className="font-medium">{result.product_id}</div>
                <div className="text-sm text-gray-500 truncate">{result.product_naam}</div>
                <div className="text-xs text-gray-400">Eenheid: {result.eenheid || 'Onbekend'}</div>
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <div className="p-2 text-center text-gray-500">Geen resultaten gevonden</div>
      )}
    </div>
  );
};

export default ProductSearchResults;
